import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { getDynamicdata } from "../../../../components/pages/campaigns/services";
import Paginated from "./Paginated";
import { COLUMNS } from "./column"
import { Link } from "react-router-dom";
import { getDisplayDateIST } from "../../../../utils/helper";
import UpdateStatusModal from "./UpdateStatusModal";

const Support = () => {
    const [loader, setLoader] = useState(false);
    const [rawList, setRawList] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        fetchSupportDetails();
    }, []);

    const fetchSupportDetails = async () => {
        setLoader(true);

        let tempToken = JSON.parse(
            localStorage.getItem("token_gen")
        );

        const res = await getDynamicdata(
            tempToken?.access_token,
            "requestData.dataType",
            "CustomerQuery"
        );

        if (res.message === "Success") {
            const data = res?.data || [];
            setRawList(data?.reverse() || []);
        }

        setLoader(false);
    };

    const openUpdateModal = (item) => {
        setSelectedItem(item);
        setModalShow(true);
    };

    const closeUpdateModal = () => {
        setModalShow(false);
        setSelectedItem(null);
    };

    const handleUpdated = (updatedItem) => {
        setRawList((prev) =>
            prev.map((item) => (item.id === updatedItem.id ? updatedItem : item))
        );
    };

    const resolveRequestDate = (item) => {
        const candidates = [
            item?.requestData?.createdAt,
            item?.requestData?.createdDate,
            item?.requestData?.date,
            item?.requestData?.dateTime,
            item?.requestData?.requestDate,
            item?.requestData?.timestamp,
            item?.createdAt,
            item?.createdDate,
            item?.timestamp,
        ];

        return candidates.find(
            (val) => val !== undefined && val !== null && val !== ""
        );
    };

    const supportList = rawList.map((item) => {
        const status = item?.requestData?.status || "Open";
        const isClosed = ["close", "closed"].includes(status?.toLowerCase?.());
        const rawDate = resolveRequestDate(item);

        return {
            ...item,
            name: (
                <Link to={`/customer-view/${item?.requestData?.customerCode}`}>
                    {item?.requestData?.name || "-"}
                </Link>
            ),
            subject: item?.requestData?.subject,
            description: item?.requestData?.description,
            createdAt: getDisplayDateIST(rawDate) || rawDate || "-",
            status: (
                <span style={{ color: isClosed ? "#dc3545" : "#198754", fontWeight: 600 }}>
                    {isClosed ? "Close" : "Open"}
                </span>
            ),
            action: (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => openUpdateModal(item)}
                >
                    Update Status
                </button>
            ),
        };
    });

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div><div></div><div></div><div></div>
                        <div></div><div></div><div></div><div></div>
                    </div>
                </div>
            )}

            <Header name={"Retailer Request"} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Retailer Request Details</h4>
                            </div>
                        </div>

                        <div className="dashboard__body">
                            <Paginated
                                columns={COLUMNS}
                                data={supportList || []}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <UpdateStatusModal
                show={modalShow}
                close={closeUpdateModal}
                item={selectedItem}
                onUpdated={handleUpdated}
            />
        </>
    );
};

export default Support;
